import { createSlice } from '@reduxjs/toolkit';

import { ApiStatus, CartState } from '../types';
import store from './store';
import endPoints from '../api/endpoint';
import {
  deleteApiCall,
  getApiCall,
  postApiCall,
  putApiCall,
} from '../api/methods';
import { notify } from '../Utils/toastify';
import { setCommonDataLoader } from './commonSlice';

import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const initialState: CartState = {
  status: false,
  activeEventsData: {},
  apiStatus: ApiStatus.idle,
  activeLocations: {},
  productions: {},
  activeProductions: {},
  inactiveProductions: {},
  upcomingProductions: {},
  userTypeList: {},
  contactList: {},
  userList: {},
  branchDetaildata: {},
  grupsLists: {},
  serviceList: {},
  serviceDetails: {},
  loader: false,
  orderList: {},
  accesslist: {},
  businessAddress: {},
  orderLocation: {},
  deliveryCheck: {},
  schdulesTypes: {},
  cartDetails: {},
  cabService: {},
  viewshiftdetails: {},
  similarserviceDetails: {},
  cabBookingDetails: {},
  setAdressesList: {},
  openUpdateModal: false,
  loadingOverlay: false,
  locationsData: {},
  locations: {},
  poNumber: {},
};
const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setLoaderStatus: (state, action) => {
      const { payload } = action;
      state.loader = payload;
    },

    setCartDetails: (state, action) => {
      const { payload } = action;
      state.cartDetails = payload;
    },
    setCabService: (state, action) => {
      const { payload } = action;
      state.cabService = payload;
    },
    setViewShiftDetails: (state, action) => {
      const { payload } = action;
      state.viewshiftdetails = payload;
    },
    setCabBookingDetails: (state, action) => {
      const { payload } = action;
      state.cabBookingDetails = payload;
    },
    setSetAddressList: (state, action) => {
      const { payload } = action;
      state.setAdressesList = payload;
    },
    setOpenUpdateModal: (state, action) => {
      const { payload } = action;
      state.openUpdateModal = payload;
    },
    setLoadingOverlay: (state, action) => {
      const { payload } = action;
      state.loadingOverlay = payload;
    },
    setLocationsData: (state, action) => {
      const { payload } = action;
      state.locationsData = payload;
    },
    setLocations: (state, action) => {
      const { payload } = action;
      state.locations = payload;
    },
    setPoNumber: (state, action) => {
      const { payload } = action;
      state.poNumber = payload;
    },
  },
});
export const {
  setLoaderStatus,
  setCartDetails,
  setCabService,
  setViewShiftDetails,
  setCabBookingDetails,
  setSetAddressList,
  setOpenUpdateModal,
  setLoadingOverlay,
  setLocationsData,
  setLocations,
  setPoNumber,
} = cartSlice.actions;

export const getCart = (isLoading?: boolean, cb?: any) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.cart;
  if (isLoading) {
    dispatch(setCommonDataLoader(true));
  }

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (isLoading) {
        dispatch(setCommonDataLoader(false));
      }

      if (data?.data) {
        dispatch(setCartDetails(data?.data));
        dispatch(setLoaderStatus(false));
        if (cb) cb();
      }
    },
    (e: any) => {
      if (isLoading) {
        dispatch(setCommonDataLoader(false));
      }
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export const updateCartNotes = (cartId: string | any, values: any) => {
  // return (dispatch: any, getState: any) => {
  console.log('dataToSend', values);
  // dispatch(setCommonDataLoader(true))
  putApiCall(
    `${endPoints.riskCenter.cart}/${cartId}/note`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const updateServiceNotes = (cartId: string | any, values: any) => {
  // return (dispatch: any, getState: any) => {
  console.log('dataToSend', values);
  // dispatch(setCommonDataLoader(true))
  putApiCall(
    `${endPoints.riskCenter.cart}/${cartId}/change-service-period`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const updateRushFees = (cartId: string | any, values: any, cb?: any) => {
  const { dispatch } = store;

  dispatch(setLoadingOverlay(true));
  putApiCall(
    `${endPoints.riskCenter.cart}/${cartId}/rush-fee`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        // notify(message, 'success');
        // if (cb) cb();
        getCart(false, cb);
      }
    },
    (e: any) => {
      dispatch(setLoadingOverlay(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const updateNotes = (cartId: string | any, values: any) => {
  // return (dispatch: any, getState: any) => {
  console.log('dataToSend', values);
  // dispatch(setCommonDataLoader(true))
  putApiCall(
    `${endPoints.riskCenter.cart}/${cartId}/note`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        getCart(false);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const updateProductsQty = (cartId: any, values: any, cb: any) => {
  const { dispatch } = store;
  dispatch(setLoadingOverlay(true));
  putApiCall(
    `${endPoints.riskCenter.updateProducts}/${cartId}/qty`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        // cb();
        // dispatch(setLoadingOverlay(false));
        getCart(false, cb);
      }
    },
    (e: any) => {
      dispatch(setLoadingOverlay(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const deleteOrderCart = (cartId: string | any, values: any) => {
  const { dispatch } = store;
  dispatch(setLoadingOverlay(true));
  deleteApiCall(
    `${endPoints.riskCenter.updateProducts}/${cartId}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (statusCode && statusCode === 200) {
        getCart(false, () => dispatch(setLoadingOverlay(false)));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const updateServicePeriod = (
  cartId: string | any,
  values: any,
  cb?: any,
) => {
  putApiCall(
    `${endPoints.riskCenter.cart}/${cartId}/change-service-period`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if ((statusCode && statusCode === 200) || statusCode === 202) {
        if (cb) {
          cb();
        }
        notify(message, 'success');
        getCart(false);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getViewShiftDetails = (
  cartIds?: string,
  dateRange?: { from: any; to: any },
) => {
  const { dispatch } = store;
  let apiendpoint = endPoints.riskCenter.shiftDetail;

  if (!dateRange) {
    console.error('Date range is required for fetching shift details.');
    return;
  }

  // Ensure `from` and `to` are Dayjs instances
  const from = dayjs(dateRange.from);
  const to = dayjs(dateRange.to);

  apiendpoint = `${apiendpoint}?fromDate=${from
    .startOf('day')
    .valueOf()}&toDate=${to.endOf('day').valueOf()}`;

  if (cartIds) {
    apiendpoint += `&cartIds=${cartIds}`;
  }

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setViewShiftDetails(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const updateCabService = (type: string | any, data: any) => {
  const { dispatch, getState } = store;

  dispatch(
    setCabService({ ...getState()?.riskCenter.cabService, [type]: data }),
  );
};

export const placeOrder = (values: any, cb?: any, setIsDisabled?: any) => {
  postApiCall(
    endPoints.riskCenter.order,
    values,
    (s: any) => {
      // console.log('s=>>>', s);
      const {
        data: { statusCode, message, data },
      } = s;

      // console.log('data=>>>', data);

      if (statusCode && statusCode === 200) {
        // if (cb) cb(data);
        if (cb) cb({ data, message });
      }
    },
    (e: any) => {
      console.log(e, 'eee');
      setIsDisabled(false);
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const draftCart = (cb?: any) => {
  postApiCall(
    endPoints.riskCenter.draft,
    {},
    (s: any) => {
      const {
        data: { statusCode, message, data },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      console.log(e, 'eee');
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const updateDescription = (values: any, cb?: any) => {
  postApiCall(
    `${endPoints.riskCenter.addDescription}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (statusCode && statusCode === 200) {
        notify(message, 'success');

        if (cb) cb();
        getCart(false);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};
export const addOrUpdatePoNumber = (values: any, cb?: any, errorCb?: any) => {
  putApiCall(
    `${endPoints.order.poNumber}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (statusCode && statusCode === 200) {
        notify('Po Number Updated Successfully.', 'success');

        if (cb) cb();
        getCart(false);
      }
    },
    (e: any) => {
      errorCb?.();
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const addToCabOrder = (payload: any, reset: any, cb?: () => void) => {
  postApiCall(
    `${endPoints.riskCenter.bookCabService}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify('Cab Book Successfully.', 'success');
        reset();
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getSets = (id?: string): Promise<any[]> => {
  const apiEndpoint = `${endPoints?.production.setListWeb}?productionId=${id}`;

  return new Promise((resolve, reject) => {
    getApiCall(
      `${apiEndpoint}`,
      (s: any) => {
        const { data } = s;
        if (data && data.data) {
          console.log(data, 'kwjgfegif');
          console.log(data.data, 'data.data');
          resolve(data.data);
        } else {
          resolve([]);
        }
      },
      (e: any) => {
        console.log(e);
        notify(`Error while fetching department list`, 'error');
        resolve([]); // Resolve with empty array on error
      },
    );
  });
};

export const updateLocation = (payload: {
  cartIds: string[];
  setId: string;
  oldSetId: string;
  setName: string;
  locations: {
    latitude: number;
    longitude: number;
    oldLocationId: string;
    locationId: string;
    locationName: string;
  }[];
}): Promise<any> => {
  const apiEndpoint = `${endPoints?.cart.updateLocation}`;

  return new Promise((resolve, reject) => {
    putApiCall(
      apiEndpoint,
      payload,
      (response: any) => {
        notify('Location updated successfully', 'success');
        getCart(false); // Refresh cart after successful update
        resolve(response);
      },
      (error: any) => {
        notify('Error while updating location', 'error');
        reject(error);
      },
    );
  });
};

export const getSetAddress = (id?: string) => {
  const { dispatch } = store;
  const apiEndpoint = `${endPoints?.cart.getSetAddresses}`;

  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data && data.data) {
        dispatch(setSetAddressList(data.data?.data));
      }
    },
    (e: any) => {
      console.log(e);
      notify(`Error while fetching department list`, 'error');
    },
  );
};

export const addItemsInCart = (values: any, cb?: any, errCallback?: any) => {
  postApiCall(
    endPoints.cart.addItems,
    values,
    (s: any) => {
      const {
        data: { statusCode, msg },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(msg, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        errCallback();
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const addItemsInOrder = (values: any, cb?: any, errCallback?: any) => {
  postApiCall(
    endPoints.cart.orderAddItems,
    values,
    (s: any) => {
      const {
        data: { statusCode, msg },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(msg, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        errCallback();
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const getCartLocationsCount = (id: any) => {
  console.log(id, 'cartIds');
  const { dispatch } = store;
  const apiendpoint = `${endPoints?.cart.getLocationCount}?cartIds=${id?.join(
    ',',
  )}`;

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setLocationsData(data?.data));
        // dispatch(setLoaderStatus(false));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getLocation = (id?: string): Promise<any> => {
  console.log(id, 'cartIds');
  const { dispatch } = store;
  const apiendpoint = `${endPoints?.cart.getLocation}?setId=${id}`;

  return new Promise((resolve, reject) => {
    getApiCall(
      apiendpoint,
      (s: any) => {
        const { data } = s;

        if (data?.data) {
          dispatch(setLocations(data?.data));
          resolve(data.data); // resolve with fetched data
        } else {
          resolve(null); // or resolve with null if no data
        }
      },
      (e: any) => {
        if (e?.data && e?.data.message) {
          notify(e?.data.message, 'error');
        }
        reject(e); // reject Promise on error
      },
    );
  });
};

export const makeCardPayment = (payload: any, cb?: any, errCallback?: any) => {
  postApiCall(
    endPoints.payment.makeCardPayment,
    payload,
    (s: any) => {
      const { data } = s;
      console.log('MAKE CARD PAYMENT', data);
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        errCallback();
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const validatePoNumber = (
  poNumber: string | undefined,
  cb?: any,
  errCallback?: any,
) => {
  const { dispatch } = store;
  getApiCall(
    `${endPoints?.cart.validatePoNumber}?poNumber=${poNumber}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // dispatch(setPoNumber(data?.data));
        if (cb) cb(data?.data);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        errCallback?.();
        notify(e?.data.message, 'error');
      }
    },
  );
};

export default cartSlice.reducer;
